module.exports = __webpack_public_path__ + "static/media/sidebar-3.0436577f.jpg";